var hamburger = document.querySelector('.hamburger'),
    menu = document.querySelector('.navigation'),
    header = document.querySelector('.header'),
    body = document.body
    languageSwitcherToggle = document.querySelectorAll('.language-switcher .current');

//Toggle hamburger menu
function toggleMenu() {
    hamburger.classList.toggle('hamburger--open');
    menu.classList.toggle('navigation--open');
    header.classList.toggle('menu-open');
    body.classList.toggle('menu-open');
}

hamburger.addEventListener('click', toggleMenu);

if (languageSwitcherToggle) {
    languageSwitcherToggle.forEach(function (el, key) {
        el.addEventListener('click', function (e) {
            this.parentElement.classList.toggle('language-switcher--open');
            this.nextElementSibling.classList.toggle('language--open');
        });
    });
}

//Add arrow if item has a submenu
document.querySelectorAll('.navigation > ul > li').forEach(function (element) {
    if (element.querySelector('.submenu')) {
        var clickableArrow = document.createElement('span');

        clickableArrow.addEventListener('click', function (e) {
            e.preventDefault();
            element.classList.toggle('sub-open');
            document.querySelector('.submenu').classList.toggle('sub-open');
            hamburger.classList.toggle('hamburger--sub-open');
        });
        element.insertBefore(clickableArrow, element.querySelector('.submenu'));
    }

    if (element.querySelector('.megamenu')) {
        element.classList.add('category');
    }
});
